module.exports = __webpack_public_path__ + "img/MONEYOU.4d266b15.jpg";